/**
 * Holds init promises
 * Format: key: $couchdbName, value: Promise
 */
var initPromises = {};

/**
 * Holds auth promises
 * Format: key: $couchdbName, value: Promise
 */
var authPromises = {};

const createPromise = () => {
  let resolve, reject;
  let p = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  p._resolve = resolve;
  p._reject = reject;
  return p;
};

/**
 * Used interernally by `CouchDB`, when initialization (connection with the server) is requested (Doesn't matter it's connected OR not).
 * @param {String} couchdbName
 */
export const _resolveInitPromise = (couchdbName) => {
  if (initPromises[couchdbName]) {
    initPromises[couchdbName]._resolve();
    console.debug(`dreamdb.couchdb[${couchdbName}] initialized`);
    return;
  }

  initPromises[couchdbName] = Promise.resolve();
  console.debug(`dreamdb.couchdb[${couchdbName}] initialized`);
};

/**
 * Used interernally by `CouchDB`, when authentication is done successfully with the server.
 * @param {String} couchdbName
 */
export const _resolveAuthPromise = (couchdbName) => {
  if (authPromises[couchdbName]) {
    authPromises[couchdbName]._resolve();
    console.debug(`dreamdb.couchdb[${couchdbName}] authenticated`);
    return;
  }

  authPromises[couchdbName] = Promise.resolve();
  console.debug(`dreamdb.couchdb[${couchdbName}] authenticated`);
};

/**
 * Used interernally by `CouchDB`, when couchdb is disposed
 * @param {String} couchdbName
 */
export const _resetPromises = (couchdbName) => {
  delete initPromises[couchdbName];
  delete authPromises[couchdbName];
};

export const waitForInit = (couchdbName = "default") => {
  if (initPromises[couchdbName]) {
    return initPromises[couchdbName];
  }

  initPromises[couchdbName] = createPromise();
  return initPromises[couchdbName];
};

export const waitForAuth = (couchdbName = "default") => {
  if (authPromises[couchdbName]) {
    return authPromises[couchdbName];
  }

  authPromises[couchdbName] = createPromise();
  return authPromises[couchdbName];
};
